var _style, _polygon, _polygon2, _polygon3, _defs, _path, _defs2, _path2, _defs3, _path3, _defs4, _polygon4, _defs5, _polygon5, _defs6, _path4, _defs7, _path5, _defs8, _path6, _defs9, _polygon6, _defs0, _path7, _defs1, _polygon7, _defs10, _polygon8, _defs11, _path8, _defs12, _path9, _defs13, _path0, _defs14, _rect, _defs15, _path1, _defs16, _polygon9, _defs17, _path10, _defs18, _path11, _defs19, _path12, _defs20, _path13, _defs21, _path14, _defs22, _path15, _defs23, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCecLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-241 371.4 127.6 51.7",
    style: {
      enableBackground: "new -241 371.4 127.6 51.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#00A8A8;}\n\t.st1{clip-path:url(#SVGID_4_);fill:#00A8A8;}\n\t.st2{clip-path:url(#SVGID_6_);fill:#00A8A8;}\n\t.st3{clip-path:url(#SVGID_8_);fill:#00A8A8;}\n\t.st4{clip-path:url(#SVGID_10_);fill:#00A8A8;}\n\t.st5{clip-path:url(#SVGID_12_);fill:#00A8A8;}\n\t.st6{clip-path:url(#SVGID_14_);fill:#00A8A8;}\n\t.st7{clip-path:url(#SVGID_16_);}\n\t.st8{clip-path:url(#SVGID_18_);fill:#00A8A8;}\n\t.st9{clip-path:url(#SVGID_20_);fill:#00A8A8;}\n\t.st10{clip-path:url(#SVGID_22_);fill:#00A8A8;}\n\t.st11{clip-path:url(#SVGID_24_);fill:#00A8A8;}\n\t.st12{clip-path:url(#SVGID_26_);fill:#00A8A8;}\n\t.st13{clip-path:url(#SVGID_28_);fill:#00A8A8;}\n\t.st14{clip-path:url(#SVGID_30_);fill:#00A8A8;}\n\t.st15{clip-path:url(#SVGID_32_);fill:#00A8A8;}\n\t.st16{clip-path:url(#SVGID_34_);fill:#00A8A8;}\n\t.st17{clip-path:url(#SVGID_36_);fill:#00A8A8;}\n\t.st18{clip-path:url(#SVGID_38_);}\n\t.st19{clip-path:url(#SVGID_40_);}\n\t.st20{clip-path:url(#SVGID_42_);}\n\t.st21{clip-path:url(#SVGID_44_);}\n\t.st22{clip-path:url(#SVGID_46_);}\n\t.st23{clip-path:url(#SVGID_48_);}\n\t.st24{clip-path:url(#SVGID_50_);}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "-241,382.8 -241,388 -240.6,388 -240.6,385.7 -234.4,385.7 -234.4,385.2 -240.6,385.2 -240.6,382.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "-241,376.8 -241,377.2 -237.9,377.2 -237.9,381.4 -241,381.4 -241,381.9 -234.4,381.9 -234.4,381.4 -237.5,381.4  -237.5,377.2 -234.4,377.2 -234.4,376.8 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "-234.8,371.5 -234.8,375 -237.5,375 -237.5,372.1 -237.9,372.1 -237.9,375 -240.6,375 -240.6,371.5 -241,371.5  -241,375.5 -234.4,375.5 -234.4,371.5 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-217.1,384.1c0.2,0,0.3,0.1,0.4,0.2l1.2,1.3c-0.7,0.8-1.5,1.5-2.5,1.9c-1,0.4-2.1,0.7-3.5,0.7 c-1.2,0-2.3-0.2-3.3-0.6c-1-0.4-1.8-1-2.5-1.7c-0.7-0.7-1.2-1.6-1.6-2.7c-0.4-1-0.6-2.2-0.6-3.4c0-1.2,0.2-2.4,0.6-3.4 c0.4-1,1-1.9,1.7-2.7c0.7-0.7,1.6-1.3,2.7-1.7c1-0.4,2.2-0.6,3.4-0.6c1.2,0,2.3,0.2,3.2,0.6c0.9,0.4,1.7,0.9,2.4,1.6l-1,1.4 c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.3-0.7-0.4c-0.3-0.2-0.6-0.3-1.1-0.4 c-0.4-0.1-1-0.2-1.6-0.2c-0.8,0-1.5,0.1-2.1,0.4c-0.6,0.3-1.2,0.7-1.7,1.2c-0.5,0.5-0.8,1.1-1.1,1.8c-0.3,0.7-0.4,1.5-0.4,2.4 c0,0.9,0.1,1.8,0.4,2.5c0.3,0.7,0.6,1.3,1.1,1.8c0.4,0.5,1,0.9,1.6,1.1c0.6,0.3,1.3,0.4,2,0.4c0.4,0,0.8,0,1.1-0.1 c0.3,0,0.7-0.1,0.9-0.2c0.3-0.1,0.6-0.2,0.8-0.4c0.3-0.2,0.5-0.3,0.8-0.6c0.1-0.1,0.2-0.1,0.2-0.2 C-217.3,384.1-217.2,384.1-217.1,384.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-209.4,381.8h5.2l-2-5.5c-0.1-0.2-0.2-0.5-0.3-0.9s-0.2-0.7-0.3-1.1c-0.1,0.4-0.2,0.7-0.3,1.1 c-0.1,0.3-0.2,0.6-0.3,0.9L-209.4,381.8z M-198.8,388h-2.4c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.3-0.3-0.4-0.5l-1.2-3.4h-6.8 l-1.2,3.4c-0.1,0.2-0.2,0.3-0.4,0.5c-0.2,0.1-0.4,0.2-0.7,0.2h-2.4l6.5-16.5h3.1L-198.8,388z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-194.1,379.4h1.9c0.6,0,1.1-0.1,1.5-0.2c0.4-0.1,0.8-0.3,1.1-0.6c0.3-0.3,0.5-0.6,0.6-0.9 c0.1-0.4,0.2-0.7,0.2-1.2c0-0.8-0.3-1.5-0.8-1.9c-0.6-0.4-1.4-0.7-2.5-0.7h-2C-194.1,373.9-194.1,379.4-194.1,379.4z  M-194.1,381.6v6.4h-3.1v-16.5h5c1.1,0,2.1,0.1,2.9,0.3c0.8,0.2,1.5,0.6,2,1c0.5,0.4,0.9,0.9,1.1,1.5c0.2,0.6,0.4,1.2,0.4,1.9 c0,0.6-0.1,1.1-0.2,1.6c-0.2,0.5-0.4,0.9-0.7,1.3c-0.3,0.4-0.7,0.8-1.1,1.1c-0.5,0.3-1,0.5-1.5,0.7c0.4,0.2,0.7,0.5,1,0.9l4.1,6.1 h-2.8c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.3-0.3-0.5-0.5l-3.5-5.3c-0.1-0.2-0.3-0.3-0.4-0.4c-0.2-0.1-0.4-0.1-0.7-0.1H-194.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "-172.3,371.5 -172.3,374 -179.6,374 -179.6,378.5 -173.9,378.5 -173.9,380.9 -179.6,380.9  -179.6,385.6 -172.3,385.6 -172.3,388 -182.7,388 -182.7,371.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-159.6,371.5 -159.6,374 -166.9,374 -166.9,378.5 -161.1,378.5 -161.1,380.9 -166.9,380.9  -166.9,385.6 -159.6,385.6 -159.6,388 -170,388 -170,371.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-154.1,379.4h1.9c0.6,0,1.1-0.1,1.5-0.2c0.4-0.1,0.8-0.3,1.1-0.6s0.5-0.6,0.6-0.9c0.1-0.4,0.2-0.7,0.2-1.2 c0-0.8-0.3-1.5-0.8-1.9c-0.5-0.4-1.4-0.7-2.5-0.7h-2L-154.1,379.4L-154.1,379.4z M-154.1,381.6v6.4h-3.1v-16.5h5 c1.1,0,2.1,0.1,2.9,0.3c0.8,0.2,1.5,0.6,2,1c0.5,0.4,0.9,0.9,1.1,1.5s0.4,1.2,0.4,1.9c0,0.6-0.1,1.1-0.2,1.6 c-0.2,0.5-0.4,0.9-0.7,1.3c-0.3,0.4-0.7,0.8-1.1,1.1c-0.5,0.3-1,0.5-1.5,0.7c0.4,0.2,0.7,0.5,1,0.9l4.1,6.1h-2.8 c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.3-0.3-0.5-0.5l-3.5-5.3c-0.1-0.2-0.3-0.3-0.4-0.4c-0.2-0.1-0.4-0.1-0.7-0.1H-154.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-133.8,374.5c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.1-0.4,0.1s-0.3-0.1-0.5-0.2c-0.2-0.1-0.4-0.2-0.7-0.4 c-0.3-0.1-0.6-0.3-0.9-0.4c-0.3-0.1-0.8-0.2-1.2-0.2c-0.4,0-0.8,0.1-1.1,0.2c-0.3,0.1-0.6,0.2-0.8,0.4c-0.2,0.2-0.4,0.4-0.5,0.7 c-0.1,0.3-0.2,0.5-0.2,0.8c0,0.4,0.1,0.7,0.3,1c0.2,0.3,0.5,0.5,0.9,0.7c0.4,0.2,0.8,0.3,1.2,0.5c0.5,0.1,0.9,0.3,1.4,0.5 c0.5,0.2,0.9,0.4,1.4,0.6c0.5,0.2,0.9,0.5,1.2,0.8c0.4,0.3,0.6,0.7,0.9,1.2c0.2,0.5,0.3,1.1,0.3,1.7c0,0.7-0.1,1.4-0.4,2.1 c-0.3,0.7-0.6,1.2-1.1,1.7c-0.5,0.5-1.1,0.9-1.8,1.1c-0.7,0.3-1.5,0.4-2.4,0.4c-0.5,0-1-0.1-1.6-0.2c-0.5-0.1-1-0.2-1.5-0.4 c-0.5-0.2-0.9-0.4-1.3-0.7c-0.4-0.3-0.8-0.6-1.1-0.9l0.9-1.5c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.1,0.4-0.1 c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.5,0.3,0.8,0.5c0.3,0.2,0.7,0.4,1.1,0.5c0.4,0.2,0.9,0.2,1.5,0.2c0.9,0,1.6-0.2,2-0.6 c0.5-0.4,0.7-1,0.7-1.8c0-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.5-0.5-0.9-0.7c-0.4-0.2-0.8-0.3-1.2-0.5s-0.9-0.3-1.4-0.4 c-0.5-0.2-0.9-0.3-1.4-0.5c-0.5-0.2-0.9-0.5-1.2-0.8c-0.4-0.3-0.6-0.8-0.9-1.3c-0.2-0.5-0.3-1.1-0.3-1.9c0-0.6,0.1-1.2,0.4-1.8 c0.2-0.6,0.6-1.1,1-1.5c0.5-0.4,1-0.8,1.7-1.1c0.7-0.3,1.4-0.4,2.3-0.4c1,0,1.9,0.2,2.7,0.5c0.8,0.3,1.5,0.7,2.1,1.3L-133.8,374.5 z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-126.7,383.8c0,0.6,0.1,1.1,0.3,1.5c0.2,0.4,0.5,0.8,0.9,1.1c0.4,0.3,0.8,0.5,1.2,0.7 c0.4,0.1,0.9,0.2,1.3,0.2c0.5,0,1-0.1,1.5-0.2s0.9-0.3,1.3-0.5c0.4-0.2,0.8-0.5,1.1-0.8c0.3-0.3,0.7-0.6,1-1l-5.2-5.1 c0,0-0.1-0.1-0.1-0.1c-0.5,0.2-1,0.5-1.4,0.8c-0.4,0.3-0.8,0.6-1,1c-0.3,0.4-0.5,0.8-0.7,1.2 C-126.6,382.9-126.7,383.4-126.7,383.8 M-121.5,371.7c0.5,0,1,0.1,1.4,0.3c0.5,0.2,0.9,0.4,1.2,0.7c0.3,0.3,0.6,0.6,0.8,1 c0.2,0.4,0.3,0.8,0.3,1.2c-0.1,0-0.2,0-0.3,0.1c-0.2,0-0.3,0.1-0.4,0.1c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.2 c-0.1-0.2-0.1-0.4-0.3-0.7c-0.1-0.3-0.3-0.5-0.5-0.7c-0.2-0.2-0.5-0.4-0.8-0.6c-0.3-0.2-0.7-0.2-1.2-0.2c-0.5,0-0.9,0.1-1.2,0.2 c-0.4,0.1-0.7,0.3-1,0.6c-0.3,0.3-0.5,0.6-0.6,0.9c-0.1,0.4-0.2,0.7-0.2,1.2c0,0.6,0.2,1.2,0.5,1.8s0.8,1.2,1.5,1.8l5.1,5 c0.3-0.5,0.6-1.1,0.8-1.7c0.2-0.6,0.3-1.2,0.4-1.7c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.1,0.2-0.1h0.6c0,0.7-0.1,1.4-0.4,2.2 c-0.3,0.8-0.6,1.5-1.1,2.2l3.4,3.3h-1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.3-0.2l-2.3-2.3c-0.3,0.4-0.7,0.8-1.1,1.1 c-0.4,0.3-0.9,0.6-1.3,0.9c-0.5,0.2-1,0.4-1.5,0.6c-0.5,0.1-1.1,0.2-1.7,0.2c-0.6,0-1.1-0.1-1.7-0.3c-0.6-0.2-1-0.5-1.5-0.8 c-0.4-0.4-0.8-0.8-1.1-1.4c-0.3-0.5-0.4-1.1-0.4-1.8c0-0.5,0.1-1.1,0.3-1.6c0.2-0.5,0.5-1,0.8-1.4c0.3-0.4,0.7-0.8,1.2-1.1 c0.5-0.3,1-0.6,1.5-0.8c-0.5-0.6-0.9-1.2-1.2-1.8c-0.3-0.6-0.4-1.2-0.4-1.8c0-0.5,0.1-1,0.3-1.5c0.2-0.5,0.5-0.8,0.8-1.2 c0.4-0.3,0.8-0.6,1.3-0.8C-122.6,371.8-122.1,371.7-121.5,371.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-230.6,391.6 -230.6,394 -237.9,394 -237.9,398.6 -232.2,398.6 -232.2,400.9 -237.9,400.9  -237.9,405.6 -230.6,405.6 -230.6,408 -241,408 -241,391.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-226.3,391.6c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.3l8.6,11 c0-0.3-0.1-0.5-0.1-0.8c0-0.3,0-0.5,0-0.7v-10h2.7V408h-1.6c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.3-0.2-0.5-0.4l-8.6-11 c0,0.2,0,0.5,0,0.7c0,0.2,0,0.5,0,0.7V408h-2.7v-16.5h1.6C-226.5,391.6-226.4,391.6-226.3,391.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-199.8,391.6 -199.8,394.1 -204.7,394.1 -204.7,408 -207.8,408 -207.8,394.1 -212.8,394.1  -212.8,391.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "-187.8,391.6 -187.8,394 -195.1,394 -195.1,398.6 -189.3,398.6 -189.3,400.9 -195.1,400.9  -195.1,405.6 -187.8,405.6 -187.8,408 -198.2,408 -198.2,391.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M-182.3,399.4h1.9c0.6,0,1.1-0.1,1.5-0.2c0.4-0.1,0.8-0.3,1.1-0.6c0.3-0.3,0.5-0.6,0.6-0.9 c0.1-0.4,0.2-0.7,0.2-1.2c0-0.8-0.3-1.5-0.8-1.9c-0.5-0.4-1.4-0.7-2.5-0.7h-2C-182.3,393.9-182.3,399.4-182.3,399.4z  M-182.3,401.6v6.4h-3.1v-16.5h5c1.1,0,2.1,0.1,2.9,0.3c0.8,0.2,1.5,0.6,2,1c0.5,0.4,0.9,0.9,1.1,1.5c0.2,0.6,0.4,1.2,0.4,1.9 c0,0.6-0.1,1.1-0.2,1.6c-0.2,0.5-0.4,0.9-0.7,1.3c-0.3,0.4-0.7,0.8-1.1,1.1c-0.5,0.3-1,0.5-1.5,0.7c0.4,0.2,0.7,0.5,1,0.9l4.1,6.1 h-2.8c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.3-0.3-0.5-0.5l-3.5-5.3c-0.1-0.2-0.3-0.3-0.4-0.4c-0.2-0.1-0.4-0.1-0.7-0.1L-182.3,401.6 L-182.3,401.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-167.8,399.9h2.3c0.6,0,1.1-0.1,1.5-0.2c0.4-0.1,0.8-0.3,1-0.6c0.3-0.3,0.5-0.6,0.6-1 c0.1-0.4,0.2-0.8,0.2-1.3c0-0.4-0.1-0.8-0.2-1.2c-0.1-0.4-0.3-0.7-0.6-0.9c-0.3-0.2-0.6-0.4-1-0.6c-0.4-0.1-0.9-0.2-1.5-0.2h-2.3 V399.9z M-167.8,402.2v5.8h-3.1v-16.5h5.4c1.1,0,2.1,0.1,2.9,0.4c0.8,0.3,1.5,0.6,2,1.1c0.5,0.5,0.9,1,1.2,1.7 c0.2,0.6,0.4,1.4,0.4,2.1c0,0.8-0.1,1.5-0.4,2.2c-0.3,0.7-0.7,1.2-1.2,1.7c-0.5,0.5-1.2,0.8-2,1.1c-0.8,0.3-1.7,0.4-2.8,0.4 L-167.8,402.2L-167.8,402.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-154.1,399.4h1.9c0.6,0,1.1-0.1,1.5-0.2c0.4-0.1,0.8-0.3,1.1-0.6c0.3-0.3,0.5-0.6,0.6-0.9 c0.1-0.4,0.2-0.7,0.2-1.2c0-0.8-0.3-1.5-0.8-1.9c-0.5-0.4-1.4-0.7-2.5-0.7h-2V399.4z M-154.1,401.6v6.4h-3.1v-16.5h5 c1.1,0,2.1,0.1,2.9,0.3c0.8,0.2,1.5,0.6,2,1c0.5,0.4,0.9,0.9,1.1,1.5s0.4,1.2,0.4,1.9c0,0.6-0.1,1.1-0.2,1.6 c-0.2,0.5-0.4,0.9-0.7,1.3c-0.3,0.4-0.7,0.8-1.1,1.1c-0.5,0.3-1,0.5-1.5,0.7c0.4,0.2,0.7,0.5,1,0.9l4.1,6.1h-2.8 c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.3-0.3-0.5-0.5l-3.5-5.3c-0.1-0.2-0.3-0.3-0.4-0.4c-0.2-0.1-0.4-0.1-0.7-0.1L-154.1,401.6 L-154.1,401.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -142.5,
    y: 391.6,
    className: "st15",
    width: 3.1,
    height: 16.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-127.2,394.6c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3-0.1-0.5-0.2 c-0.2-0.1-0.4-0.2-0.7-0.4c-0.3-0.1-0.6-0.3-0.9-0.4c-0.3-0.1-0.8-0.2-1.2-0.2c-0.4,0-0.8,0.1-1.1,0.2c-0.3,0.1-0.6,0.2-0.8,0.4 c-0.2,0.2-0.4,0.4-0.5,0.7c-0.1,0.3-0.2,0.5-0.2,0.8c0,0.4,0.1,0.7,0.3,1c0.2,0.3,0.5,0.5,0.9,0.7c0.4,0.2,0.8,0.3,1.2,0.5 c0.5,0.1,0.9,0.3,1.4,0.5c0.5,0.2,0.9,0.4,1.4,0.6c0.5,0.2,0.9,0.5,1.2,0.8s0.6,0.7,0.9,1.2c0.2,0.5,0.3,1.1,0.3,1.7 c0,0.7-0.1,1.4-0.4,2.1c-0.3,0.6-0.6,1.2-1.1,1.7c-0.5,0.5-1.1,0.9-1.8,1.1c-0.7,0.3-1.5,0.4-2.4,0.4c-0.5,0-1-0.1-1.5-0.2 s-1-0.2-1.5-0.4c-0.5-0.2-0.9-0.4-1.3-0.7c-0.4-0.3-0.8-0.6-1.1-0.9l0.9-1.5c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.1,0.4-0.1 c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.5,0.3,0.8,0.5c0.3,0.2,0.7,0.4,1.1,0.5c0.4,0.2,0.9,0.2,1.5,0.2c0.9,0,1.6-0.2,2-0.6 c0.5-0.4,0.7-1,0.7-1.8c0-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.5-0.5-0.9-0.7c-0.4-0.2-0.8-0.3-1.2-0.5c-0.5-0.1-0.9-0.3-1.4-0.4 c-0.5-0.2-0.9-0.3-1.4-0.5c-0.5-0.2-0.9-0.5-1.2-0.8c-0.4-0.3-0.6-0.8-0.9-1.3c-0.2-0.5-0.3-1.1-0.3-1.9c0-0.6,0.1-1.2,0.4-1.8 c0.2-0.6,0.6-1.1,1-1.5c0.5-0.4,1-0.8,1.7-1.1s1.4-0.4,2.3-0.4c1,0,1.9,0.2,2.7,0.5c0.8,0.3,1.5,0.7,2.1,1.3L-127.2,394.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "-113.4,391.6 -113.4,394 -120.7,394 -120.7,398.6 -115,398.6 -115,400.9 -120.7,400.9 -120.7,405.6  -113.4,405.6 -113.4,408 -123.8,408 -123.8,391.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-176.3,421c0.1,0,0.1,0,0.1,0.1l0.3,0.3c-0.2,0.2-0.5,0.5-0.7,0.7c-0.3,0.2-0.6,0.4-0.9,0.5 c-0.3,0.1-0.7,0.2-1,0.3c-0.4,0.1-0.8,0.1-1.3,0.1c-0.8,0-1.5-0.1-2.1-0.4c-0.6-0.3-1.2-0.6-1.6-1.1c-0.5-0.5-0.8-1.1-1.1-1.8 c-0.3-0.7-0.4-1.5-0.4-2.3c0-0.8,0.1-1.6,0.4-2.3c0.3-0.7,0.6-1.3,1.1-1.8c0.5-0.5,1-0.9,1.7-1.1c0.7-0.3,1.4-0.4,2.2-0.4 c0.4,0,0.8,0,1.1,0.1c0.3,0.1,0.6,0.1,0.9,0.3c0.3,0.1,0.6,0.2,0.8,0.4c0.3,0.2,0.5,0.4,0.7,0.6l-0.2,0.3c0,0.1-0.1,0.1-0.2,0.1 c0,0-0.1,0-0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2-0.1-0.3-0.2-0.6-0.3c-0.2-0.1-0.5-0.1-0.8-0.2 c-0.3-0.1-0.6-0.1-1-0.1c-0.7,0-1.3,0.1-1.8,0.3c-0.6,0.2-1,0.6-1.4,1c-0.4,0.4-0.7,0.9-0.9,1.5c-0.2,0.6-0.3,1.3-0.3,2 c0,0.8,0.1,1.5,0.3,2.1c0.2,0.6,0.5,1.1,0.9,1.5c0.4,0.4,0.9,0.7,1.4,1c0.5,0.2,1.1,0.3,1.7,0.3c0.4,0,0.7,0,1-0.1 c0.3-0.1,0.6-0.1,0.8-0.2c0.3-0.1,0.5-0.2,0.7-0.4c0.2-0.1,0.4-0.3,0.7-0.5C-176.5,421.1-176.4,421.1-176.3,421 C-176.4,421-176.4,421-176.3,421"
  }))), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_39_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M-165.3,417.4c0-0.8-0.1-1.5-0.3-2.1c-0.2-0.6-0.5-1.1-0.9-1.6c-0.4-0.4-0.8-0.7-1.4-1 c-0.5-0.2-1.1-0.3-1.8-0.3c-0.7,0-1.2,0.1-1.8,0.3s-1,0.5-1.4,1c-0.4,0.4-0.7,0.9-0.9,1.6c-0.2,0.6-0.3,1.3-0.3,2.1 c0,0.8,0.1,1.5,0.3,2.1c0.2,0.6,0.5,1.1,0.9,1.5c0.4,0.4,0.9,0.7,1.4,1c0.5,0.2,1.1,0.3,1.8,0.3c0.7,0,1.3-0.1,1.8-0.3 c0.5-0.2,1-0.5,1.4-1c0.4-0.4,0.7-0.9,0.9-1.5C-165.4,418.8-165.3,418.2-165.3,417.4 M-164.5,417.4c0,0.8-0.1,1.6-0.4,2.3 s-0.6,1.3-1.1,1.8c-0.5,0.5-1,0.9-1.7,1.1c-0.6,0.3-1.4,0.4-2.1,0.4c-0.8,0-1.5-0.1-2.1-0.4c-0.6-0.3-1.2-0.6-1.6-1.1 c-0.5-0.5-0.8-1.1-1.1-1.8c-0.3-0.7-0.4-1.5-0.4-2.3c0-0.8,0.1-1.6,0.4-2.3c0.3-0.7,0.6-1.3,1.1-1.8c0.5-0.5,1-0.9,1.6-1.1 c0.6-0.3,1.3-0.4,2.1-0.4c0.8,0,1.5,0.1,2.1,0.4c0.6,0.3,1.2,0.6,1.7,1.1c0.5,0.5,0.8,1.1,1.1,1.8S-164.5,416.5-164.5,417.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_41_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-157.4,420.1c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0.1-0.2,0.1-0.2l4.3-7.6c0-0.1,0.1-0.1,0.1-0.1c0,0,0.1,0,0.2,0 h0.5v11h-0.7v-9.3c0-0.1,0-0.3,0-0.4l-4.3,7.7c-0.1,0.1-0.2,0.2-0.3,0.2h-0.1c-0.1,0-0.2-0.1-0.3-0.2l-4.4-7.7c0,0.1,0,0.3,0,0.4 v9.3h-0.7v-11h0.5c0.1,0,0.1,0,0.2,0c0,0,0.1,0.1,0.1,0.1l4.4,7.6C-157.5,419.8-157.4,420-157.4,420.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_43_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M-148.9,417.8h2c0.5,0,0.9-0.1,1.3-0.2c0.4-0.1,0.7-0.3,1-0.6c0.3-0.2,0.5-0.5,0.6-0.8 c0.1-0.3,0.2-0.7,0.2-1.1c0-0.8-0.3-1.5-0.8-1.9c-0.5-0.5-1.3-0.7-2.3-0.7h-2L-148.9,417.8L-148.9,417.8z M-148.9,418.5v4.4h-0.8 v-11h2.8c1.3,0,2.3,0.3,2.9,0.8c0.7,0.6,1,1.4,1,2.4c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.8-0.8,1c-0.3,0.3-0.7,0.5-1.2,0.7 c-0.5,0.2-1,0.2-1.6,0.2H-148.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_45_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M-141.2,418.9h4.9l-2.2-5.5c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.4c0,0.1-0.1,0.2-0.1,0.4 c0,0.1-0.1,0.2-0.1,0.3L-141.2,418.9z M-133.9,422.9h-0.6c-0.1,0-0.1,0-0.2-0.1c0,0-0.1-0.1-0.1-0.2l-1.3-3.2h-5.4l-1.3,3.2 c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1h-0.6l4.5-11h0.8L-133.9,422.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_47_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M-131.8,411.9c0,0,0.1,0.1,0.1,0.1l7.1,9.5c0-0.2,0-0.3,0-0.4v-9.2h0.7v11h-0.4c-0.1,0-0.2-0.1-0.3-0.2 l-7.1-9.5c0,0.2,0,0.3,0,0.4v9.2h-0.7v-11h0.4C-131.9,411.9-131.9,411.9-131.8,411.9"
  }))), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_49_",
    x: -241,
    y: 371.4,
    width: 127.6,
    height: 51.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M-117.5,418.4v4.5h-0.8v-4.5l-4.1-6.4h0.7c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.1l3.1,5 c0.1,0.1,0.1,0.2,0.2,0.3s0.1,0.2,0.1,0.3c0-0.1,0.1-0.2,0.1-0.3s0.1-0.2,0.2-0.3l3.1-5c0-0.1,0.1-0.1,0.1-0.1 c0,0,0.1-0.1,0.2-0.1h0.7L-117.5,418.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCecLogo);
export default __webpack_public_path__ + "static/media/cec-logo.be5511e8912f4a550dadc843657f0c35.svg";
export { ForwardRef as ReactComponent };